import React from "react";
import PropTypes from "prop-types";
import DayPicker from "react-day-picker";
import DayPickerInput from "react-day-picker/DayPickerInput";
import classNames from "classnames";

import moment from "moment";
import MomentLocaleUtils, {
  formatDate,
  parseDate
} from "react-day-picker/moment";
import "moment/locale/ru";

class Datepicker extends React.Component {
  handleDayChange = selectedDay => {
    if (this.props.disabled) {
      return false;
    }

    const name = this.props.name || "";
    const value = selectedDay ? moment(selectedDay).format("DD.MM.YYYY") : "";

    this.props.onChange(name, value);
  };

  getSelectedDay = value => {
    if (value) {
      let date = moment(value, "DD.MM.YYYY");

      if (date.isValid()) {
        return date.toDate();
      } else {
        date = moment(value, "MM/DD/YYYY");

        if (date.isValid()) {
          return date.toDate();
        } else {
          return new Date();
        }
      }
    } else {
      return new Date();
    }
  };

  render() {
    const {
      datepickerFullClassName,
      datepickerContainerClassName,
      datepickerOverlayWrapperClassName,
      datepickerOverlayClassName,
      full
    } = this.props;

    /* CLASS */
    const fullClasses = classNames(
      "datepicker-full",
      { "datepicker-disabled": this.props.disabled },
      datepickerFullClassName
    );
    const containerClasses = classNames(
      "datepicker-container",
      { "datepicker-disabled": this.props.disabled },
      datepickerContainerClassName
    );
    const overlayWrapperClasses = classNames(
      "datepicker-overlay-wrapper",
      datepickerOverlayWrapperClassName
    );
    const overlayClasses = classNames(
      "datepicker-overlay",
      datepickerOverlayClassName
    );

    if (full) {
      return (
        <DayPicker
          canChangeMonth={!this.props.disabled}
          enableOutsideDaysClick={!this.props.disabled}
          className={fullClasses}
          locale="ru"
          localeUtils={MomentLocaleUtils}
          todayButton="Сегодня"
          fixedWeeks={true}
          month={this.getSelectedDay(this.props.value)}
          selectedDays={this.getSelectedDay(this.props.value)}
          onDayClick={this.props.disabled ? null : this.handleDayChange}
          onTodayButtonClick={this.props.disabled ? null : this.handleDayChange}
        />
      );
    } else {
      return (
        <DayPickerInput
          formatDate={formatDate}
          parseDate={parseDate}
          format="L"
          dayPickerProps={{
            locale: "ru",
            localeUtils: MomentLocaleUtils,
            todayButton: "Сегодня",
            fixedWeeks: true,
            month: this.getSelectedDay(this.props.value)
          }}
          placeholder={this.props.placeholder}
          value={this.props.value}
          inputProps={this.props.inputProps}
          onDayChange={this.handleDayChange}
          classNames={{
            container: containerClasses,
            overlayWrapper: overlayWrapperClasses,
            overlay: overlayClasses
          }}
        />
      );
    }
  }
}

Datepicker.defaultProps = {
  full: false,
  value: "",
  disabled: false,
  onChange: () => {
    return null;
  },
  inputProps: {},
  datepickerFullClassName: null,
  datepickerContainerClassName: null,
  datepickerOverlayWrapperClassName: null,
  datepickerOverlayClassName: null
};

Datepicker.propTypes = {
  type: PropTypes.oneOf(["date", "month"]),
  full: PropTypes.bool,
  name: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  inputProps: PropTypes.object,
  datepickerFullClassName: PropTypes.string,
  datepickerContainerClassName: PropTypes.string,
  datepickerOverlayWrapperClassName: PropTypes.string,
  datepickerOverlayClassName: PropTypes.string
};

export default Datepicker;
